// function setupWishlistButtons() {
//   // This function now has one simple job: sync all buttons based on their current data.
//   function syncAllButtonStates() {
//     if (!window._swat || !window._swat.api || typeof window._swat.api.fetch !== 'function') return;

//     window._swat.api.fetch(function(wishlistItems) {
//       if (!wishlistItems) return;
//       const allButtons = document.querySelectorAll('.swym-wishlist-button');
      
//       allButtons.forEach(button => {
//         const variantId = parseInt(button.dataset.variantId, 10);
//         const isWishlisted = wishlistItems.some(item => item.epi === variantId);
        
//         if (isWishlisted) {
//           button.classList.add('swym-added');
//         } else {
//           button.classList.remove('swym-added');
//         }
//       });
//     });
//   }

//   // --- Main Click Listener (No changes needed here) ---
//   const allButtons = document.querySelectorAll('[data-custom-swym-add="true"]');
//   allButtons.forEach(button => {
//     button.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();

//       const clickedButton = this;
//       let variantId;
//       const productForm = document.querySelector('product-info form[id^="product-form-"]');
//       const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;

//       if (variantInput && clickedButton.closest('.product__media-wrapper')) {
//         variantId = parseInt(variantInput.value, 10);
//       } else {
//         variantId = parseInt(clickedButton.dataset.variantId, 10);
//       }
      
//       const productId = JSON.parse(clickedButton.dataset.productId);
//       const productUrlContainer = clickedButton.closest('[data-url]');
//       const baseUrl = productUrlContainer ? productUrlContainer.dataset.url : window.location.pathname;

//       const productUrl = new URL(window.location.origin + baseUrl);
//       productUrl.searchParams.set('variant', variantId);

//       const productData = {
//         epi: variantId,
//         empi: productId,
//         du: productUrl.href
//       };

//       window._swat.ui.performAddToWishlist(productData, function() {
//         setTimeout(syncAllButtonStates, 250);
//       });
//     });
//   });
  
//   // --- Variant Change Listener ---
//   // Find all possible variant selector elements
//   const variantSelectors = document.querySelectorAll('input[name="id"], select[name="id"], input[type="radio"][name*="option"], select[name*="option"]');

//   // Function to update wishlist button
//   function updateWishlistButton() {
//     // Get the current selected variant ID
//     const productForm = document.querySelector('form[id*="product-form"]');
//     const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    
//     if (!variantInput) return;
    
//     const newVariantId = parseInt(variantInput.value, 10);
    
//     // Find the wishlist button
//     const wishlistButton = document.querySelector('.swym-wishlist-button') || 
//                           document.querySelector('[data-custom-swym-add="true"]');
    
//     if (wishlistButton && newVariantId) {
//       // Update button data
//       wishlistButton.dataset.variantId = newVariantId;
//       wishlistButton.id = `custom-wishlist-button-${newVariantId}`;
      
//       // Update wishlist state
//       if (window._swat && window._swat.api && typeof window._swat.api.fetch === 'function') {
//         window._swat.api.fetch(function(wishlistItems) {
//           if (!wishlistItems) return;
//           const isWishlisted = wishlistItems.some(item => item.epi === newVariantId);
          
//           if (isWishlisted) {
//             wishlistButton.classList.add('swym-added');
//           } else {
//             wishlistButton.classList.remove('swym-added');
//           }
//         });
//       }
//     }
//   }

//   // Add listeners to all variant selectors
//   variantSelectors.forEach(selector => {
//     selector.addEventListener('change', function(event) {
//       setTimeout(updateWishlistButton, 100); // Small delay to ensure form is updated
//     });
//   });

//   // Also listen for clicks on variant option buttons (for button-style variant pickers)
//   const variantButtons = document.querySelectorAll('input[type="radio"][name*="option"]');
//   variantButtons.forEach(button => {
//     button.addEventListener('change', function() {
//       setTimeout(updateWishlistButton, 100);
//     });
//   });

//   // Listen for any clicks on variant-related elements
//   document.addEventListener('click', function(event) {
//     if (event.target.matches('input[name*="option"], label[for*="option"], .variant-input, .variant-option')) {
//       setTimeout(updateWishlistButton, 200);
//     }
//   });

//   // Run the initial sync on page load
//   setTimeout(syncAllButtonStates, 750);
// }

// // Run the setup once the page's HTML is ready.
// document.addEventListener('DOMContentLoaded', setupWishlistButtons);

function setupWishlistButtons() {
  // This function now has one simple job: sync all buttons based on their current data.
  function syncAllButtonStates() {
    if (!window._swat || !window._swat.api || typeof window._swat.api.fetch !== 'function') return;

    window._swat.api.fetch(function(wishlistItems) {
      if (!wishlistItems) return;
      const allButtons = document.querySelectorAll('.swym-wishlist-button');
      
      allButtons.forEach(button => {
        const variantId = parseInt(button.dataset.variantId, 10);
        const isWishlisted = wishlistItems.some(item => item.epi === variantId);
        
        if (isWishlisted) {
          button.classList.add('swym-added');
        } else {
          button.classList.remove('swym-added');
        }
      });
    });
  }

  // --- Main Click Listener ---
  const allButtons = document.querySelectorAll('[data-custom-swym-add="true"]');
  allButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const clickedButton = this;
      let variantId;
      const productForm = document.querySelector('product-info form[id^="product-form-"]');
      const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;

      if (variantInput && clickedButton.closest('.product__media-wrapper')) {
        variantId = parseInt(variantInput.value, 10);
      } else {
        variantId = parseInt(clickedButton.dataset.variantId, 10);
      }
      
      const productId = JSON.parse(clickedButton.dataset.productId);
      const productUrlContainer = clickedButton.closest('[data-url]');
      const baseUrl = productUrlContainer ? productUrlContainer.dataset.url : window.location.pathname;

      const productUrl = new URL(window.location.origin + baseUrl);
      productUrl.searchParams.set('variant', variantId);

      const productData = {
        epi: variantId,
        empi: productId,
        du: productUrl.href
      };

      window._swat.ui.performAddToWishlist(productData, function() {
        setTimeout(syncAllButtonStatesEnhanced, 250);
      });
    });
  });
  
  // --- Variant Change Listener ---
  const variantSelectors = document.querySelectorAll('input[name="id"], select[name="id"], input[type="radio"][name*="option"], select[name*="option"]');

  function updateWishlistButton() {
    const productForm = document.querySelector('form[id*="product-form"]');
    const variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    
    if (!variantInput) return;
    
    const newVariantId = parseInt(variantInput.value, 10);
    
    const wishlistButton = document.querySelector('.swym-wishlist-button') || 
                          document.querySelector('[data-custom-swym-add="true"]');
    
    if (wishlistButton && newVariantId) {
      wishlistButton.dataset.variantId = newVariantId;
      wishlistButton.id = `custom-wishlist-button-${newVariantId}`;
      
      if (window._swat && window._swat.api && typeof window._swat.api.fetch === 'function') {
        window._swat.api.fetch(function(wishlistItems) {
          if (!wishlistItems) return;
          const isWishlisted = wishlistItems.some(item => item.epi === newVariantId);
          
          if (isWishlisted) {
            wishlistButton.classList.add('swym-added');
          } else {
            wishlistButton.classList.remove('swym-added');
          }
        });
      }
    }
  }

  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function(event) {
      setTimeout(updateWishlistButton, 100);
    });
  });

  const variantButtons = document.querySelectorAll('input[type="radio"][name*="option"]');
  variantButtons.forEach(button => {
    button.addEventListener('change', function() {
      setTimeout(updateWishlistButton, 100);
    });
  });

  document.addEventListener('click', function(event) {
    if (event.target.matches('input[name*="option"], label[for*="option"], .variant-input, .variant-option')) {
      setTimeout(updateWishlistButton, 200);
    }
  });

  // --- Enhanced sync function for AJAX content ---
  function syncAllButtonStatesEnhanced() {
    if (!window._swat || !window._swat.api || typeof window._swat.api.fetch !== 'function') {
      setTimeout(syncAllButtonStatesEnhanced, 500);
      return;
    }

    window._swat.api.fetch(function(wishlistItems) {
      if (!wishlistItems) return;
      
      const allButtons = document.querySelectorAll('.swym-wishlist-button');
      
      allButtons.forEach(button => {
        const variantId = parseInt(button.dataset.variantId, 10);
        const isWishlisted = wishlistItems.some(item => item.epi === variantId);
        
        if (isWishlisted) {
          button.classList.add('swym-added');
        } else {
          button.classList.remove('swym-added');
        }
        
        // Add click listener if not already added
        if (button.dataset.customSwymAdd === "true" && !button.hasAttribute('data-listener-added')) {
          button.setAttribute('data-listener-added', 'true');
          button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            const clickedButton = this;
            const variantId = parseInt(clickedButton.dataset.variantId, 10);
            const productId = JSON.parse(clickedButton.dataset.productId);
            const productUrlContainer = clickedButton.closest('[data-url]');
            const baseUrl = productUrlContainer ? productUrlContainer.dataset.url : window.location.pathname;

            const productUrl = new URL(window.location.origin + baseUrl);
            productUrl.searchParams.set('variant', variantId);

            const productData = {
              epi: variantId,
              empi: productId,
              du: productUrl.href
            };

            window._swat.ui.performAddToWishlist(productData, function() {
              setTimeout(syncAllButtonStatesEnhanced, 250);
            });
          });
        }
      });
    });
  }

  // Handle AJAX-loaded content
  const observer = new MutationObserver(function(mutations) {
    let hasNewButtons = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        const newButtons = Array.from(mutation.addedNodes)
          .filter(node => node.nodeType === Node.ELEMENT_NODE)
          .flatMap(node => {
            if (node.matches && node.matches('.swym-wishlist-button')) {
              return [node];
            }
            return node.querySelectorAll ? Array.from(node.querySelectorAll('.swym-wishlist-button')) : [];
          });
        
        if (newButtons.length > 0) {
          hasNewButtons = true;
        }
      }
    });
    
    if (hasNewButtons) {
      setTimeout(syncAllButtonStatesEnhanced, 100);
      setTimeout(syncAllButtonStatesEnhanced, 500);
      setTimeout(syncAllButtonStatesEnhanced, 1000);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Multiple initial syncs to catch AJAX content
  setTimeout(syncAllButtonStatesEnhanced, 750);
  setTimeout(syncAllButtonStatesEnhanced, 1500);
  setTimeout(syncAllButtonStatesEnhanced, 3000);
}

document.addEventListener('DOMContentLoaded', setupWishlistButtons);